import { render, staticRenderFns } from "./icon-plus.vue?vue&type=template&id=06a99f49&scoped=true&"
import script from "./icon-plus.vue?vue&type=script&lang=js&"
export * from "./icon-plus.vue?vue&type=script&lang=js&"
import style0 from "./icon-plus.vue?vue&type=style&index=0&id=06a99f49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a99f49",
  null
  
)

export default component.exports